import { Navigate, Route, Routes } from 'react-router-dom';

import Sidebar from '../../layouts/Sidebar';

import { getUserPage } from './utilities/helpers';

const User = ({ route }: { route: Route }) => (
  <Sidebar route={route}>
    <Routes>
      {route.routes?.map((route) => (
        <Route element={getUserPage(route)} key={route.id} path={route.path} />
      ))}
      <Route element={<Navigate replace to={route.routes[0]?.path} />} path="*" />
    </Routes>
  </Sidebar>
);

export default User;
